// Number of skeleton cards to show while loading, per product group.
// Groups not listed here default to 4.
const PRODUCT_GROUP_SKELETON_COUNTS = {
  HUBSPOT_FOR_MARKETERS: 2,
  SMART_CRM: 2,
  FREE: 2,
  COMMERCE: 3
};
const DEFAULT_SKELETON_COUNT = 4;
export function getProductGroupSkeletonCount(group) {
  var _PRODUCT_GROUP_SKELET;
  return (_PRODUCT_GROUP_SKELET = PRODUCT_GROUP_SKELETON_COUNTS[group]) !== null && _PRODUCT_GROUP_SKELET !== void 0 ? _PRODUCT_GROUP_SKELET : DEFAULT_SKELETON_COUNT;
}